import classNames from 'classnames'
import { Form } from 'informed'
import React, { useCallback, useRef, useState, useEffect } from 'react'
import { TyRadioGroup } from '@tymbe/ty-components/inputs/radio'
import { TyRadio } from '@tymbe/ty-components/inputs/radio/Radio'
import useSearchString from '../../../hooks/UrlParamsHandler/useSearchParams'
import { ContentIcon } from '@tymbe/ui-icons';

export enum ShiftFilterOptions {
  ALL = 'all',
  NOT_FULL =  'not_full',
  UNCONFIRMED_ATTENDANCE = 'unconfirmed_attendance',
};

const ShiftFilter = () => {
  const dropdownRef = useRef<HTMLDivElement | null>(null);

  const [showFilter, setShowFilter] = useState(false);
  const [searchParams, setSearchParams] = useSearchString();
  const shiftFilter = searchParams.get('shiftFilter') || ShiftFilterOptions.ALL;
  const [showFilterIndicator, setShowFilterIndicator] = useState(shiftFilter!==ShiftFilterOptions.ALL);


  const handleShiftFilter = useCallback((filter: ShiftFilterOptions) => {
    if (!filter) return;
    const newFilter = filter
    const newParams = new URLSearchParams(searchParams);
    if (newFilter === ShiftFilterOptions.ALL) {
      newParams.delete('shiftFilter');
      setShowFilterIndicator(false)
    } else {
      newParams.set('shiftFilter', newFilter);
      setShowFilterIndicator(true)
    }
    setSearchParams(newParams);
  }, [searchParams, setSearchParams]);

  const handleClickOutside = useCallback((event: MouseEvent) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target as Node)) {
      setShowFilter(false);
    }
  }, []);

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [handleClickOutside]);

  return (
    <div className='relative' ref={dropdownRef}>
      <button
        onClick={() => setShowFilter(!showFilter)}
        type='button'
        className={classNames(
          "flex shadow-down-xs h-full rounded-lg border items-center justify-center px-3",
          "hover:bg-secondary-50 border-secondary-100"

        )}>
          <ContentIcon name="filter_list" className='size-4 text-secondary-600' />
          {showFilterIndicator &&
            <span className="absolute top-2 right-2 z-40 size-3 rounded-full border-2 border-white bg-blue-600"></span>
          }
      </button>

      {showFilter &&
        <div
          className={classNames(
          'flex flex-col rounded-lg bg-white absolute top-12 z-50 w-fit gap-4 p-4 border border-secondary-100 shadow-down-md',
          )}
          >
          <div className='text-body-1-xl font-semibold whitespace-nowrap'>Zobrazit směny</div>
            <Form onChange={({values}) => handleShiftFilter(values.shiftFilter)} >
              <TyRadioGroup className='text-body-2-xl flex whitespace-nowrap flex-col gap-4' name="shiftFilter" required defaultValue={shiftFilter}>
                <TyRadio className='flex gap-3' value={ShiftFilterOptions.ALL} label='Všechny' />
                <TyRadio className='flex gap-3' value={ShiftFilterOptions.NOT_FULL} label='Pouze nezaplněné' />
                <TyRadio className='flex gap-3' value={ShiftFilterOptions.UNCONFIRMED_ATTENDANCE} label='S nepotvrzenou docházkou' />
              </TyRadioGroup>
          </Form>
        </div>
      }
    </div>
  )
}

export default ShiftFilter
